<template>
  <div class="left-side" :class="{'left-collapse':$root.layout.sideBarCollapse}">
    <div class="logo">
      <a href="#" v-show="!$root.layout.sideBarCollapse"><img src="../../assets/logo-inside.png"/></a>
      <a href="#" v-show="$root.layout.sideBarCollapse"><img src="../../assets/logo-collapse.png"/></a>
    </div>
    <div class="menu">
      <el-menu
        :collapse="$root.layout.sideBarCollapse"
        :default-active="$route.path"
        class="left-menu"
        background-color="#2f3640"
        text-color="#828BA0"
        active-text-color="#D0D8E9"

        :router="true">

        <el-menu-item v-for="menu,key in menuList" :index="menu.path" :key="key"
                      v-if="$root.checkRole(menu.roles)">
          <i :class="menu.icon"></i>
          <span v-html="menu.label"></span>
        </el-menu-item>

<!--        <component v-for="component in componentList" :key="component" v-bind:is="component"></component>-->

      </el-menu>

    </div>
  </div>
</template>

<script>

  import menuJson from './../../resources/menu';

  export default {
    name: 'LeftSide',
    data() {
      return {
        activeIndex: 'companies',
        menuList: menuJson.menu,
        componentList: menuJson.components
      }
    },
    created() {

    },
    methods: {
      handleSelect(key, keyPath) {

      }
    },
    computed: {
      onRoutes() {
        return this.$route.path;
      }
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Base/LeftSide.vue